import normalize from "json-api-normalizer";
import { get } from "lodash";
import { decamelize } from "humps";

import {
  FETCH_DELETE_SUMMARY_SUCCESS,
  FETCH_DELETE_SUMMARY_FAILED,
  FETCH_DELETE_SUMMARY_START,
  DELETE_RECORD_SUCCESS,
  DELETE_RECORD_FAILED
} from "./types";
import DeleteService from "../services/delete.service";
import NotificationService from "../services/notification.service";

export const fetchDeleteSummary = (resourceName, recordSlug) => async (dispatch, getState) => {
  const tenantSlug = get(getState(), "common.currentTenant.slug");
  let apiVersion = "v1";

  const resource = decamelize(resourceName);

  dispatch({ type: FETCH_DELETE_SUMMARY_START });

  try {
    const result = await DeleteService.getDeleteSummary(resource, recordSlug, tenantSlug, apiVersion);

    const normalizedData = normalize(result.data);

    dispatch({ type: FETCH_DELETE_SUMMARY_SUCCESS, payload: normalizedData });
  } catch (error) {
    dispatch({ type: FETCH_DELETE_SUMMARY_FAILED });
  }
};

export const deleteRecord = (resourceName, recordSlug) => async (dispatch, getState) => {
  const tenantSlug = get(getState(), "common.currentTenant.slug");
  let apiVersion = "v1";

  const resource = decamelize(resourceName);

  try {
    await DeleteService.deleteRecord(resource, recordSlug, tenantSlug, apiVersion);

    dispatch({ type: DELETE_RECORD_SUCCESS, resource: resourceName, recordSlug: recordSlug, apiVersion });

    NotificationService.addSuccess("Record successfully deleted!");
  } catch (e) {
    dispatch({ type: DELETE_RECORD_FAILED });

    NotificationService.addError(`Failed deleting the record! ${NotificationService.handleMessage(e)}`);
  }
};
